import React from 'react';
import './secondOpinion.css';
import docpatImage from '../../../assets/images/logo/docpat.png';

const SecondOpinion = () => {
    return (
        <div className="row" style={{ minHeight: '80vh' }}>
            {/* Left Column */}
            <div className="col-12 col-md-6 d-flex flex-column justify-content-center text-center">
                <div>
                    <div className="fw-bold text-danger mb-2 fs-5 blinking-text">
                        Coming Soon
                    </div>
                    <div className="text-secondary mx-auto fw-italic fs-5 text-dark" style={{ maxWidth: 630 }}>
                        A medical professional's opinion about a patient's health problem and treatment plan, given when it's different from the patient's current doctor's opinion.
                    </div>
                </div>
            </div>

            {/* Right Column - Background image */}
            <div
                className="col-12 col-md-6"
                style={{
                    background: `url(${docpatImage}) no-repeat center right`,
                    backgroundSize: "contain",
                    minHeight: 400,
                    minWidth: 300,
                }}
            ></div>
        </div>
    );
};

export default SecondOpinion;
